var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pr-2 flex items-center"},[_vm._t("default"),_c('abbr',{staticClass:"ml-2 whitespace-no-wrap",class:[ _vm.isSideNavCollapsed ? 'hidden' : 'inline-block']},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }